'use strict';

angular.module('programme')

.directive('mobileImage', function ($uibModal, assetCache, $window, $timeout, debounce)
{
    function controller ($scope, $element)
    {
        var component = $element.controller('component');

        // Backward compatibility property mapping
        if ($scope.data.imageConfig) {
            $scope.data.width = $scope.data.imageConfig.width + $scope.data.imageConfig.unit;
        }

        $scope.data.asset_id = $scope.data.asset_id || null;
        $scope.data.mobile_asset_id = $scope.data.mobile_asset_id || null;

        $scope.data.caption = $scope.data.caption || '';
        $scope.data.ratio = $scope.data.ratio || [16,9];
        $scope.data.overlayPos = $scope.data.overlayPos || 'bottom';
        $scope.data.anchor = $scope.data.anchor || 'Centre Middle';
        $scope.data.width = $scope.data.width || '100%';

        // Computed properties
        $scope.computed = {
            width: Number(splitValue($scope.data.width)[1]),
            widthUnit: splitValue($scope.data.width)[2],
            style: {},
            url: component.options.placeholderImage,
            mobile_url: null
        };

        // Component options
        $scope.overlayPositions = {
            top: 'Top',
            middle: 'Middle',
            bottom: 'Bottom'
        };

        // Scope functions
        $scope.setOverlayPosition = function (pos)
        {
            $scope.data.overlayPos = pos;
        };


        $scope.imageStyleChanged = function ()
        {
            $scope.data.width = $scope.computed.width + $scope.computed.widthUnit;

            $scope.computed.style = {
                width: $scope.data.width
            };
        };

        var resize = debounce(function () {
            $scope.imageStyleChanged();
        }, 250);

        angular.element($window).on('resize', resize);
        $scope.$on('$destroy', function () {
            angular.element($window).off('resize', resize);
        });

        $scope.$watch('data.asset_id', function ()
        {
            if (!$scope.data.asset_id) {
                $scope.computed.url = component.options.placeholderImage;
                $scope.imageStyleChanged();
                return;
            }

            assetCache.get($scope.data.asset_id).then(function (asset)
            {
                $scope.computed.url = asset.links.download;

            }).then($scope.imageStyleChanged);
        });

        $scope.$watch('data.mobile_asset_id', function ()
        {
            if (!$scope.data.mobile_asset_id) {
                $scope.computed.mobile_url = null;
                $scope.imageStyleChanged();
                return;
            }

            assetCache.get($scope.data.mobile_asset_id).then(function (asset)
            {
                $scope.computed.mobile_url = asset.links.download;

            }).then($scope.imageStyleChanged);
        });

        //$watchGroup doesn't support deep watch
        $scope.$watchGroup([
            'computed.width',
            'computed.widthUnit',
            'data.ratio[0]',
            'data.ratio[1]',
            'data.anchor'
        ], $scope.imageStyleChanged);

        // Init
        component.removeDataProperties([
            'fixedHeight',
            'height',
            'size',
            'imageWidth',
            'unit',
            'placeholder',
            'style',
            'imageConfig',
            'sources',
            'url'
        ]);
    }

    function splitValue (value)
    {
        return value.match(/^(\d+(?:\.\d+)?)(.*)$/);
    }

    function link ($scope, element, attributes, component)
    {
        $scope.imageResizable = component.options.resizable;
        $scope.imageOverlay = component.options.overlay;
    }

    return {
        replace: true,
        require: '^component',
        templateUrl: 'modules/programme/editor-components/mobile-image/mobileImage.html',
        link: link,
        controller: controller
    };
});
